export default __webpack_public_path__ + "static/gy-a0b32d50ef047cc5f009081ccfeb7de7.svg";